import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { ConfigService } from '../services/config.service';

@Injectable({
  providedIn: 'root'
})
export class ReferralGuard implements CanActivate {

  private loader$ = new Subject<boolean>();
  public loader = false;

  constructor(private configService: ConfigService, private router: Router) {
    this.loader$.pipe(debounceTime(300)).subscribe(loader => { this.loader = loader })
  }

  async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    this.setShowLoader(true);
    await this.configService.getInitialInfo()
    this.setShowLoader(false);
    if (this.configService.company_info.referral_module) return true;
    this.router.navigateByUrl('/autenticacion');
    return false;
  }

  setShowLoader(show) {
    this.loader$.next(show)
  }

}
